import type {
  Configuration,
  CreateIdpGroupRequest,
  UpdateIdpGroupRequest,
} from '@repo/api-gw-sdk';
import { IamApi } from '@repo/api-gw-sdk';

import type { HttpClient } from './httpClient';

const baseUrl = '/idpGroups';

// The gateway reads nothing out of a page token but the index after the pipe.
// Deriving it from the index rather than a fresh uuid keeps the token stable
// across renders, which is what stops SWR re-keying and refetching on each one.
const pageToken = (pageIndex: number) => btoa(`page|${pageIndex}`);

export const idpGroups = (httpClient: HttpClient, config: Configuration) => {
  const iamApi = new IamApi(config);

  return {
    useList: (pageIndex = 0, pageSize?: number) =>
      httpClient.execute(
        iamApi.listIdpGroups.bind(iamApi),
        baseUrl,
        '',
        pageIndex > 0 ? pageToken(pageIndex) : undefined,
        pageSize
      ),
    create: (input: CreateIdpGroupRequest) => iamApi.createIdpGroup(input),
    update: (groupId: string, input: UpdateIdpGroupRequest) =>
      iamApi.updateIdpGroup(groupId, input),
    delete: (groupId: string) => iamApi.deleteIdpGroup(groupId),
    // The organization's group grants that reach this account, one row per
    // group and role. Read-only: the organization console owns them, and an
    // account attached to no organization gets an empty list.
    organizationGranted: {
      useList: (enabled = true) =>
        httpClient.execute(
          iamApi.listGrantedOrganizationGroupAccess.bind(iamApi),
          enabled ? baseUrl : null,
          '/organization-granted'
        ),
    },
  };
};
